module.exports = {
        srcSet: __webpack_public_path__ + "static/media/discountCouponMobile-166.cd088fcb.webp"+" 166w",
        images: [{path: __webpack_public_path__ + "static/media/discountCouponMobile-166.cd088fcb.webp",width: 166,height: 166}],
        src: __webpack_public_path__ + "static/media/discountCouponMobile-166.cd088fcb.webp",
        toString: function(){return __webpack_public_path__ + "static/media/discountCouponMobile-166.cd088fcb.webp"},
        
        width: 166,
        height: 166
      }